
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form8";
const form8State = namespace("Form8");

import Form8ProcessHeader from "@/components/process/Form8/components/Form8ProcessHeader.vue";
import Form8 from "@/components/process/Form8/components/pdf/Form8.vue"

import { form8StatusInfoType } from '@/types/Information/Form8';

@Component({
    components:{
        Form8ProcessHeader,
        Form8
    }
})
export default class PreviewForm8 extends Vue {

    @form8State.State
    public currentNoticeOfApplicationToVaryId: string;

    stepsCompleted = {} as form8StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form8"}); 
    }
}
